import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { _ENDPOINT } from '../../../endpoints/endpoint';
import { NetworkService } from '../../../services/network.service';
import { Utility } from '../../../utility/utility';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-bundled-product-offering-view',
  templateUrl: './bundled-product-offering-view.component.html',
  styleUrls: ['./bundled-product-offering-view.component.css']
})
export class BundledProductOfferingViewComponent implements OnInit, OnDestroy {

  settingsFilter = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      category: {
        title: 'Category',
        filter: false,
        sort: false
      },
      type: {
        title: 'Type',
        filter: false,
        sort: false
      },
      productId: {
        title: 'Product ID',
        filter: false,
        sort: false
      },
      productName: {
        title: 'Product Name',
        filter: false,
        sort: false
      },
      status: {
        title: 'Status',
        filter: false,
        sort: false
      },
      startDate: {
        title: 'Start Date',
        filter: false,
        sort: false
      },
      endDate: {
        title: 'End Date',
        filter: false,
        sort: false
      }


    }
  };

  settings = {
    actions: {
      add: false,
      edit: false,
      delete: false,
    },
    columns: {
      type: {
        title: 'Type'
      },
      productId: {
        title: 'Product ID'
      },
      productName: {
        title: 'Product Name'
      },
      status: {
        title: 'Status'
      },
      startDate: {
        title: 'Start Date',
        compareFunction(direction: any, a: string, b: string) {

          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }


          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      },
      endDate: {
        title: 'End Date',
        compareFunction(direction: any, a: string, b: string) {

          let dateObjectA: any;
          let dateObjectB: any;
          if (a) {
            let datePartsA = a.split("/");
            let timePartsA = datePartsA[2].split(" - ")[1].split(":");
            datePartsA[2] = datePartsA[2].split(" - ")[0];
            dateObjectA = new Date(+datePartsA[2], +datePartsA[1] - 1, +datePartsA[0], +timePartsA[0], +timePartsA[1], +timePartsA[2]);
            console.log(dateObjectA);
          }
          if (b && dateObjectA) {
            let datePartsB = b.split("/");
            let timePartsB = datePartsB[2].split(" - ")[1].split(":");
            datePartsB[2] = datePartsB[2].split(" - ")[0];
            dateObjectB = new Date(+datePartsB[2], +datePartsB[1] - 1, +datePartsB[0], +timePartsB[0], +timePartsB[1], +timePartsB[2]);

            console.log(dateObjectB);
          }


          if (dateObjectA < dateObjectB) {
            return -1 * direction;
          }
          if (dateObjectA > dateObjectB) {
            return direction;
          }

          return 0;
        }
      }


    }
  };

  listTariff: any[] = [];
  listTariffBundled: any[] = [];
  idCatalog: string;
  idCategory: string;
  idProduct: string;
  destroy$ = new Subject<boolean>();

  constructor(private route: ActivatedRoute, private toastr: ToastrManager, private spinner: NgxSpinnerService,
    private networkService: NetworkService, private router: Router) { }

  ngOnInit(): void {
    this.idCatalog = this.route.snapshot.params['idCatalog'];
    this.idProduct = this.route.snapshot.params['idProduct'];
    this.idCategory = this.route.snapshot.params['idCategory'];
    this.initiliazeOffering();
  }

  initiliazeOffering() {
    this.spinner.show("sp1");
    let getBundledProductOffering: string = environment.basePath + _ENDPOINT.getBundledProductOffering;

    let data = Utility.createBodyForPostRequest(this.idProduct, true);
    this.networkService.post(getBundledProductOffering, data)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        if (this.networkService.checkEnvironmentIsDev()) {
          if (response && response.statusCode == '200' && response.body && response.body.length > 0) {
            let dataJson = JSON.parse(response.body);
            this.listTariff = dataJson.listTariff;
            for (let tar of this.listTariff) {
              tar.category = this.idCategory;
            }
            this.listTariffBundled = dataJson.listTariffBundled;
            this.spinner.hide("sp1");
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during bundled product offering retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            let url: string = 'tariff-and-option-view/' + this.idCatalog + '/' + this.idCategory;
            this.router.navigate([url]);
          }
        }
        else {
          if (response && response.listTariffBundled && response.listTariff) {
            this.listTariff = response.listTariff;
            for (let tar of this.listTariff) {
              tar.category = this.idCategory;
            }
            this.listTariffBundled = response.listTariffBundled;
            this.spinner.hide("sp1");
          } else if (response && response.length && response.length > 0) {
            this.spinner.hide("sp1");
            this.toastr.errorToastr(response, 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            let url: string = 'tariff-and-option-view/' + this.idCatalog + '/' + this.idCategory;
            this.router.navigate([url]);
          } else {
            this.spinner.hide("sp1");
            this.toastr.errorToastr('Error during bundled product offering retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
            let url: string = 'tariff-and-option-view/' + this.idCatalog + '/' + this.idCategory;
            this.router.navigate([url]);
          }
        }


      },
        err => {
          this.spinner.hide("sp1");
          this.toastr.errorToastr('Error during bundled product offering retrieve!', 'Error', { 'animate': 'slideFromRight', 'timeout': '3000' });
          console.error(err);
          let url: string = 'tariff-and-option-view/' + this.idCatalog + '/' + this.idCategory;
          this.router.navigate([url]);
        });;
  }

  goToTariffView() {
    let url: string = 'tariff-and-option-view/' + this.idCatalog;
    this.router.navigate([url]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
